import { useRuntime } from './RuntimeContext';
export const useSession = () => {
    const runtime = useRuntime();
    return runtime.getSession();
};
